import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import useQueryParams from 'hooks/useQueryParams';
import AnalyticsDeals from './components/AnalyticsDeals';
import { SORTING_VALUES } from './components/AnalyticsDeals/components/data';
import AnalyticsNavigation from '../Analytics/components/AnalyticsNavigation';
import { Navigate } from 'react-router-dom';
import { BUSINESS_ROUTE } from 'data/global';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

import './Deals.styles.scss';

type DealsProps = {
  className?: string;
};

const Deals: React.FC<DealsProps> = (props) => {
  const { className } = props;

  const classes = classNames('deals', className);

  const { isOfficeManager } = useContext(CurrentUserContext);

  const {
    params: { sort },
    setQueryParam,
  } = useQueryParams();

  useEffect(() => {
    if (!sort && !isOfficeManager) {
      setQueryParam('sort', SORTING_VALUES.stage);
    }
  }, [sort, setQueryParam, isOfficeManager]);

  if (isOfficeManager) return <Navigate to={BUSINESS_ROUTE} replace />;

  if (!sort) return null;

  return (
    <div className={classes}>
      <AnalyticsNavigation />
      <AnalyticsDeals />
    </div>
  );
};

export default Deals;
